(function () {
	const iconClose = () => {
		const icons = document.querySelectorAll(".icon-close");
		icons.forEach((icon) => {
			icon.addEventListener("click", function () {
				const announcement = icon.closest(".section-announcement");
				if (announcement) {
					announcement.style.display = "none";
				}
			});
		});
	};

	const initCarousel = () => {
		const carousels = document.querySelectorAll(".announcement-carousel");
		
		carousels.forEach((carousel) => {
			const track = carousel.querySelector(".announcement-carousel__track");
			const slides = carousel.querySelectorAll(".announcement-carousel__slide");
			
			if (slides.length <= 1) return;
			
			// Ensure slideWidth is calculated after DOM is ready
			const calculateSlideWidth = () => {
				const slideWidth = slides[0].offsetWidth;
				return slideWidth > 0;
			};
			
			// Wait for slideWidth to be available
			const waitForSlideWidth = () => {
				if (!calculateSlideWidth()) {
					setTimeout(waitForSlideWidth, 50);
					return;
				}
				
				// Clone first slide and append to end for seamless loop
				const firstSlide = slides[0].cloneNode(true);
				track.appendChild(firstSlide);
				
				let currentIndex = 0;
				const slideWidth = slides[0].offsetWidth;
				const totalSlides = slides.length;
				
				// Set initial position
				track.style.transform = "translateX(0)";
				track.style.transition = "transform 0.5s ease-in-out";
				
				const nextSlide = () => {
					currentIndex++;
					const translateX = -currentIndex * slideWidth;
					track.style.transform = `translateX(${translateX}px)`;
					
					// When we reach the cloned slide, reset to first slide
					if (currentIndex >= totalSlides) {
						setTimeout(() => {
							track.style.transition = "none";
							currentIndex = 0;
							track.style.transform = "translateX(0)";
							setTimeout(() => {
								track.style.transition = "transform 0.5s ease-in-out";
							}, 10);
						}, 500);
					}
				};
				
				// Auto-advance every 3 seconds
				setInterval(nextSlide, 3000);
			};
			
			// Start the initialization process
			waitForSlideWidth();
		});
	};

	const initUpsellThreeCarousel = () => {
		// Only initialize on mobile devices
		if (window.innerWidth >= 750) {
			return;
		}
		
		const upsellThreeCarousels = document.querySelectorAll(".upsell-three-carousel");
		
		upsellThreeCarousels.forEach((carousel, index) => {
			// Remove existing event listeners to prevent duplicates
			const newCarousel = carousel.cloneNode(true);
			carousel.parentNode.replaceChild(newCarousel, carousel);
			
			const track = newCarousel.querySelector(".upsell-three-carousel__track");
			const slides = newCarousel.querySelectorAll(".upsell-three-carousel__slide");
			const upsellThree = newCarousel.closest(".upsell-three");
			const prevBtn = upsellThree.querySelector(".upsell-three-nav-prev");
			const nextBtn = upsellThree.querySelector(".upsell-three-nav-next");
			
			if (slides.length <= 1) {
				return;
			}
			
			let currentIndex = 0;
			let slideWidth = 0;
			const totalSlides = slides.length;
			
			// Ensure slideWidth is calculated after DOM is ready
			const calculateSlideWidth = () => {
				slideWidth = slides[0].offsetWidth;
				return slideWidth > 0;
			};
			
			// Wait for slideWidth to be available
			const waitForSlideWidth = () => {
				if (!calculateSlideWidth()) {
					setTimeout(waitForSlideWidth, 50);
					return;
				}
				
				// Set initial position
				track.style.transform = "translateX(0)";
				track.style.transition = "transform 0.5s ease-in-out";
				
				// Initialize carousel functionality
				initCarouselFunctionality();
			};
			
			const initCarouselFunctionality = () => {
				const goToSlide = (index) => {
					currentIndex = index;
					const translateX = -currentIndex * slideWidth;
					track.style.transform = `translateX(${translateX}px)`;
					updateButtonStates();
				};
				
				const nextSlide = () => {
					if (currentIndex < totalSlides - 1) {
						goToSlide(currentIndex + 1);
					}
				};
				
				const prevSlide = () => {
					if (currentIndex > 0) {
						goToSlide(currentIndex - 1);
					}
				};
				
				// Update button states
				const updateButtonStates = () => {
					if (prevBtn) {
						prevBtn.style.opacity = currentIndex === 0 ? "0.3" : "0.7";
						prevBtn.disabled = currentIndex === 0;
					}
					if (nextBtn) {
						nextBtn.style.opacity = currentIndex === totalSlides - 1 ? "0.3" : "0.7";
						nextBtn.disabled = currentIndex === totalSlides - 1;
					}
				};
				
				// Navigation button event listeners with proper event handling
				if (prevBtn) {
					prevBtn.addEventListener("click", (e) => {
						e.preventDefault();
						e.stopPropagation();
						prevSlide();
					}, { passive: false });
				}
				
				if (nextBtn) {
					nextBtn.addEventListener("click", (e) => {
						e.preventDefault();
						e.stopPropagation();
						nextSlide();
					}, { passive: false });
				}
				
				// Touch/swipe support for mobile
				let startX = 0;
				let currentX = 0;
				let isDragging = false;
				
				const handleTouchStart = (e) => {
					startX = e.type === "mousedown" ? e.clientX : e.touches[0].clientX;
					isDragging = true;
					track.style.transition = "none";
				};
				
				const handleTouchMove = (e) => {
					if (!isDragging) return;
					
					e.preventDefault();
					currentX = e.type === "mousemove" ? e.clientX : e.touches[0].clientX;
					const diff = currentX - startX;
					const translateX = -currentIndex * slideWidth + diff;
					
					// Limit the drag range
					if (translateX > 0 || translateX < -(totalSlides - 1) * slideWidth) {
						return;
					}
					
					track.style.transform = `translateX(${translateX}px)`;
				};
				
				const handleTouchEnd = () => {
					if (!isDragging) return;
					
					isDragging = false;
					track.style.transition = "transform 0.5s ease-in-out";
					
					const diff = currentX - startX;
					const threshold = slideWidth * 0.3; // 30% of slide width
					
					if (Math.abs(diff) > threshold) {
						if (diff > 0 && currentIndex > 0) {
							prevSlide();
						} else if (diff < 0 && currentIndex < totalSlides - 1) {
							nextSlide();
						} else {
							// Snap back to current position
							goToSlide(currentIndex);
						}
					} else {
						// Snap back to current position
						goToSlide(currentIndex);
					}
				};
				
				// Add touch/mouse event listeners
				newCarousel.addEventListener("mousedown", handleTouchStart);
				newCarousel.addEventListener("mousemove", handleTouchMove);
				newCarousel.addEventListener("mouseup", handleTouchEnd);
				newCarousel.addEventListener("mouseleave", handleTouchEnd);
				
				newCarousel.addEventListener("touchstart", handleTouchStart, { passive: false });
				newCarousel.addEventListener("touchmove", handleTouchMove, { passive: false });
				newCarousel.addEventListener("touchend", handleTouchEnd);
				
				// Initial button state
				updateButtonStates();
			};
			
			// Start the initialization process
			waitForSlideWidth();
		});
	};

	iconClose();
	initCarousel();
	initUpsellThreeCarousel();
	
	// Handle window resize with debouncing
	let resizeTimeout;
	window.addEventListener("resize", function() {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			initUpsellThreeCarousel();
		}, 250);
	});
	
	document.addEventListener("shopify:section:load", function () {
		iconClose();
		initCarousel();
		initUpsellThreeCarousel();
	});
})();
